import { sentenceCase } from "change-case-all";
import { Grid, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";

import { TextField } from "../../../../components";
import { colors } from "../../../css components/Style";

function Range({
  state,
  dispatch,
  field,
  editState,
  formikProps,
  messages,
  disaptchMessage,
}) {
  const [input, setInput] = useState({});
  const [message, setMessage] = useState({});

  useEffect(() => {
    if (state[field.name]) {
      setInput((prev) => ({
        ...prev,
        [field.name]: state[field.name],
      }));
    }

    if (messages[field.name]) {
      setMessage((prev) => ({
        ...prev,
        [field.name]: messages[field.name],
      }));
    }
  }, [state, field.name, messages]);

  const handleFieldChange = (value, name, key, segmentID) => {
    if (
      !input?.[field.name]?.value?.[field.options[0].value] &&
      !input[field.name]?.value?.[field.options[1].value]
    ) {
      let noRange = "empty";
      dispatch({
        type: "RANGE_UPDATE",
        payload: { value, name, key, noRange, segmentID },
      });
    } else {
      dispatch({
        type: "RANGE_UPDATE",
        payload: { value, name, key, segmentID },
      });
    }

    disaptchMessage({
      type: "MESSAGE_UPDATE",
      payload: { value: message, key: name },
    });
  };

  function handleValueValidation(num1, num2 = 0, field, key) {
    let { min_default_val, max_default_val } = field;

    let numInt1 = parseInt(num1);
    let numInt2 = parseInt(num2);

    const newMessages = { ...message };
    const fieldMessages = newMessages[field.name] || {};
    let error = false;

    if ((num1 || num2) && (isNaN(num1) || isNaN(num2))) {
      fieldMessages[key] = sentenceCase("Please enter digits");
      error = true;
    }

    if (numInt1 && numInt2 && numInt1 > numInt2) {
      fieldMessages[key] = sentenceCase("Min should be less than max");
      error = true;
    }

    if (numInt1 < min_default_val || numInt1 > max_default_val) {
      fieldMessages[key] = sentenceCase(
        `Min should be between ${min_default_val} and ${max_default_val}.`
      );
      error = true;
    }

    if (numInt2 && (numInt2 < min_default_val || numInt2 > max_default_val)) {
      fieldMessages[key] = sentenceCase(
        `Max should be between ${min_default_val} and ${max_default_val}.`
      );
      error = true;
    }

    if (error) {
      newMessages[field.name] = fieldMessages;
    } else {
      delete newMessages[field.name];
    }

    setMessage(newMessages);
  }

  return (
    <Fragment>
      <Grid size={6}>
        <Grid container spacing={4}>
          <Grid size={6}>
            <TextField
              value={input?.[field.name]?.value?.[field.options[0].value]}
              $isFilled={input?.[field.name]?.value?.[field.options[0].value]}
              size="small"
              label={field.options[0].label}
              onBlur={(e) => {
                handleFieldChange(
                  input[field.name]?.value?.[field.options[0].value],
                  field.name,
                  `${field.options[0].value}`,
                  field.segment_id
                );
              }}
              onChange={(e) => {
                const { value } = e.target;

                setInput((prev) => ({
                  ...prev,
                  [field.name]: {
                    value: {
                      ...input[field.name]?.value,
                      [field.options[0].value]: value,
                    },
                  },
                }));

                handleValueValidation(
                  e.target.value,
                  input?.[field.name]?.value?.[field.options[1].value],
                  field,
                  field.options[0].value
                );
              }}
              name={`${field.name}.value.${field.options[0].value}`}
              placeholder={field.options[0].label}
              disabled={!editState}
            />

            <Typography color={colors.error} variant="caption">
              {message[field.name]?.[field.options[0].value]}
            </Typography>
          </Grid>

          <Grid size={6}>
            <TextField
              size="small"
              label={field.options[1].label}
              onBlur={(e) => {
                handleFieldChange(
                  input[field.name]?.value?.[field.options[1].value],
                  field.name,
                  `${field.options[1].value}`
                );
              }}
              onChange={(e) => {
                setInput((prev) => ({
                  ...prev,
                  [field.name]: {
                    value: {
                      ...input[field.name]?.value,
                      [field.options[1].value]: e.target.value,
                    },
                  },
                }));

                handleValueValidation(
                  input?.[field.name]?.value?.[field.options[0].value],
                  e.target.value,
                  field,
                  field.options[1].value
                );
              }}
              value={input?.[field.name]?.value?.[field.options[1].value]}
              $isFilled={input?.[field.name]?.value?.[field.options[1].value]}
              name={`${field.name}.value.${field.options[1].value}`}
              placeholder={field.options[1].label}
              disabled={!editState}
            />

            <Grid size={12}>
              <Typography color={colors.error} variant="caption">
                {message[field.name]?.[field.options[1].value]}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Range;
